export const API_BASE_URL = {
  main: process.env.REACT_APP_WEBTRANS_API_URL || 'https://localhost:44375/v1',
  secondary: process.env.REACT_APP_CONTAINERCONTROL_API_URL || 'https://localhost:44383/v1',
}
